import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { Session } from "@supabase/supabase-js";

interface SessionStore {
    // State
    session: Session | null;
    isLoading: boolean;

    // Actions
    setSession: (session: Session | null) => void;
    setLoading: (loading: boolean) => void;
    clearSession: () => void;

    // Computed getters
    isAuthenticated: () => boolean;
}

export const useSessionStore = create<SessionStore>()(
    devtools(
        (set, get) => ({
            // Initial state
            session: null,
            isLoading: true,

            // Actions
            setSession: (session) => {
                set({ session }, false, "setSession");
            },

            setLoading: (isLoading) => set({ isLoading }, false, "setLoading"),

            clearSession: () => {
                set({ session: null }, false, "clearSession");
            },

            // Computed getters
            isAuthenticated: () => get().session !== null,
        }),
        {
            name: "session-store",
        },
    ),
);

// Selector hooks
export const useSession = () => useSessionStore((state) => state.session);
export const useIsAuthenticated = () =>
    useSessionStore((state) => state.isAuthenticated());
export const useIsLoading = () => useSessionStore((state) => state.isLoading);
export const useSetSession = () => useSessionStore((state) => state.setSession);
export const useSetLoading = () => useSessionStore((state) => state.setLoading);
